export default __webpack_public_path__ + "locales/de/BackupCodesDialog.json?hash=5ea70d5c18d1ae6521bc045ded8f773a";